import React, {Component, Fragment} from 'react';
import CustomLoader from "../common/CustomLoader";
import Websocket from 'react-websocket';
import uuidv1 from 'uuid/v1';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import CancelIcon from '@material-ui/icons/Cancel';
import HomeIcon from '@material-ui/icons/Home';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import FilterNoneIcon from '@material-ui/icons/FilterNone';

const wsHostUrl = 'wss://flowork.ai/ws';
const reconnectIntervalInMilliSeconds = 1000;

class StreamPage extends Component {
    constructor(props) {
        super(props);
        this.refWS = null;
        this.streamConnection = null;
        this.dataConnection = null;
        this.dataChannel = null;
        this.dataChannelLabel = '';
        this.opponentDAT = '';
        this.isMouseDown = false;
        this.chunk = '';
    };

    state = {
        isRequested: false,
        isConnected: false,
        isOpenedDataChannel: false,
    };
    initializeWS = (service) => {
        const access_info = JSON.parse(sessionStorage.getItem('access_info'));
        let accessToken = '';
        let deviceAccessToken = '';
        if (access_info) {
            accessToken = access_info.access_token;
            deviceAccessToken = access_info.device_access_token
        }
        if (!deviceAccessToken || deviceAccessToken.length === 0) {
            deviceAccessToken = uuidv1();
            access_info.device_access_token = deviceAccessToken;
            sessionStorage.setItem('access_info', JSON.stringify(access_info));
        }
        let sendData = {
            category: 'ws',
            service: service,
            access_token: accessToken,
            client_type: 'chrome',
            device_access_token: deviceAccessToken,

        };
        this.sendWS({
            data: sendData
        });
    };
    sendWS = (msg) => {
        if (this.refWS) {
            console.log('SWS', 'send', msg);
            this.refWS.sendMessage(JSON.stringify(msg));
        }
    };
    onopenWS = () => {
        console.log('SWS', 'onopenWS');
        const {initializeWS} = this;
        initializeWS('Register')
    };
    onmessageWS = (e) => {
        // console.log('onmessageWS - 1', e);
        const {startToLive, onAnswerStream, onCandidateStream, createAnswerData, onAnswerData, onCandidateData} = this;

        if (e) {
            let s = e.split('\n');
            for (let i = 0; i < s.length; i++) {
                let payload = JSON.parse(s);
                // console.log("onmessageWS - 2",  payload);
                if (payload.data) {
                    const service = payload.data.service;
                    if (service === 'RegisterComplete') {
                        startToLive();
                    } else if (service === 'Answer') {
                        console.log("onmessageWS - 2",  payload);
                        if (payload.data.channel_type === 'stream') {
                            onAnswerStream(payload.data.sdp);
                        } else {
                            onAnswerData(payload.data.sdp);
                        }
                    } else if (service === 'Candidate') {
                        // CreateAnswer 보다 candidate 이 먼저 응답이 오면 이 candidate은 버려진다.
                        // 그래서 접속이 자꾸 실패함. candidate 에 대해 딜레이를 줬음. 나중에 더 나이스한 해결책이 필요함
                        if (payload.data.channel_type === 'stream') {
                            setTimeout(function () {
                                onCandidateStream(payload.data.candidate.candidate);
                            }, 1000);
                        } else {
                            setTimeout(function () {
                                onCandidateData(payload.data.candidate.candidate);
                            }, 1000);
                        }
                    } else if (service === 'Offer') {
                        createAnswerData(payload.data.sdp, payload.data.label);
                    }
                }
            }
        }
    };
    oncloseWS = () => {
        console.log('SWS', 'oncloseWS');
    };
    startToLive = () => {
        const {sendWS} = this;
        const access_info = JSON.parse(sessionStorage.getItem('access_info'));
        let accessToken = '';
        let deviceAccessToken = '';
        if (access_info) {
            accessToken = access_info.access_token;
            deviceAccessToken = access_info.device_access_token
        }

        sendWS({
            data: {
                category: 'ws',
                service: 'StartToLive',
                access_token: accessToken,
                device_access_token: deviceAccessToken,
                opponent_dat: this.opponentDAT,
                channel_type: "data",
            }
        });
    };
    setupPeerConnection = () => {
        const {sendWS} = this;
        const thisComponent = this;
        const {iceServers} = this.props;
        const access_info = JSON.parse(sessionStorage.getItem('access_info'));
        let accessToken = '';
        let deviceAccessToken = '';
        if (access_info) {
            accessToken = access_info.access_token;
            deviceAccessToken = access_info.device_access_token;
        }
        let ua = navigator.userAgent.toLowerCase();
        console.log(ua);
        if (ua.indexOf('safari') !== -1) {
            if (ua.indexOf('chrome') > -1) {
                // Chrome
                this.streamConnection = new RTCPeerConnection(iceServers)
            } else {
                // Safari
                this.streamConnection = new RTCPeerConnection({
                    iceServers: [
                        {
                            "urls": "stun:stun.l.google.com:19302"
                        }
                    ]
                });
            }
        } else {
            this.streamConnection = new RTCPeerConnection(iceServers)
        }
        console.log('SWS', 'stream', this.streamConnection);

        this.streamConnection.onclose = (e) => {
            console.log('streamConnection', 'onclose', e);
        };
        this.streamConnection.ontrack = (e) => {
            const base = document.getElementById('viewer-base');
            const video = document.getElementById('app-video');
            const thisComponent = this;
            if (video.srcObject !== e.streams[0]) {
                video.srcObject = e.streams[0];
                console.log('received remote stream');
                video.addEventListener('loadedmetadata', function () {
                    console.log(`Remote video videoWidth: ${this.videoWidth}px,  videoHeight: ${this.videoHeight}px`);
                });
                video.onresize = () => {
                    console.log(`Remote video size changed to ${video.videoWidth}x${video.videoHeight}`);
                    // We'll use the first onsize callback as an indication that video has started
                    // playing out.
                };
                video.addEventListener('mousedown', function (event) {
                    const rect = video.getBoundingClientRect()
                    const x = event.clientX - rect.left;
                    const y = event.clientY - rect.top;
                    // console.log("mousedown", "x: " + x + " y: " + y);
                    // console.log("width: " + rect.width + " height: " + rect.height);
                    if (event.button === 0) {
                        const message = JSON.stringify({
                            command: 'mouse_down',
                            x: (x / rect.width) + '',
                            y: (y / rect.height) + '',
                        });
                        // console.log(message);
                        thisComponent.dataChannel.send(message);
                        thisComponent.isMouseDown = true
                    }
                });
                video.addEventListener('mouseup', function (event) {
                    const rect = video.getBoundingClientRect()
                    const x = event.clientX - rect.left;
                    const y = event.clientY - rect.top;
                    // console.log("mouseup", "x: " + x + " y: " + y);
                    // console.log("width: " + rect.width + " height: " + rect.height);
                    if (event.button === 0) {
                        const message = JSON.stringify({
                            command: 'mouse_up',
                            x: (x / rect.width) + '',
                            y: (y / rect.height) + '',
                        });
                        // console.log(message);
                        thisComponent.dataChannel.send(message);
                    }
                });
                video.addEventListener('mousemove', function (event) {
                    const rect = video.getBoundingClientRect()
                    const x = event.clientX - rect.left;
                    const y = event.clientY - rect.top;
                    if (thisComponent.isMouseDown) {
                        const message = JSON.stringify({
                            command: 'mouse_move',
                            x: (x / rect.width) + '',
                            y: (y / rect.height) + '',
                        });
                        // console.log(message);
                        thisComponent.dataChannel.send(message);
                    }
                    // console.log("mousemove", "x: " + x + " y: " + y);
                    // console.log("width: " + rect.width + " height: " + rect.height);
                });
                document.addEventListener('mouseup', function (event) {
                    thisComponent.isMouseDown = false;
                })
                base.addEventListener('mousemove', function (event) {
                    // console.log("fab mousemove:", fab.style.top, fab.style.left, event.clientX, event.clientY);
                });
            }
        };
        this.streamConnection.onnegotiationneeded = () => {
            thisComponent.setState({
                isOpenedWebRTCRemote: true,
            });
        };
        this.streamConnection.onicecandidate = function (e) {
            console.log('SWS', 'stream candidate', e);
            if (e.candidate) {
                thisComponent.dataChannel.send(JSON.stringify({
                    data: {
                        category: 'ws',
                        service: 'Candidate',
                        access_token: accessToken,
                        opponent_dat: deviceAccessToken,
                        channel_type: "stream",
                        candidate: {
                            type: 'candidate',
                            candidate: e.candidate,
                        },
                    }
                }));
            }
        };
    };

    createAnswerSC = (offer, opponentDAT, streamLabel, handle) => {
        const thisComponent = this;
        const {sendWS, setupPeerConnection} = this;
        const channelLabel = uuidv1();
        const access_info = JSON.parse(sessionStorage.getItem('access_info'));
        let accessToken = '';
        let deviceAccessToken = '';
        if (access_info) {
            accessToken = access_info.access_token;
            deviceAccessToken = access_info.device_access_token
        }
        let ua = navigator.userAgent.toLowerCase();

        setupPeerConnection();

        const {streamConnection} = this;
        thisComponent.setState({
            isConnected: true,
        });
        streamConnection.setRemoteDescription(new RTCSessionDescription(offer));
        streamConnection.createAnswer().then(function (answer) {
            // console.log('--------------> 3', opponentDAT, thisComponent.nodes[opponentDAT].dc)
            // console.log('sc', 'createAnswer', deviceAccessToken, JSON.stringify(answer));
            thisComponent.dataChannel.send(JSON.stringify({
                data: {
                    category: 'ws',
                    service: 'Answer',
                    channel_type: 'stream',
                    opponent_dat: deviceAccessToken,
                    source: ua,
                    handle: handle,
                    label: channelLabel,
                    sdp: answer,
                },
            }));
            streamConnection.setLocalDescription(answer);
        }).catch(function (error) {
            console.log('SWS', 'An error has occurred.', error);
        });
    };
    createOfferStream = () => {
        const thisComponent = this;
        const {sendWS, setupPeerConnection} = this;

        setupPeerConnection();

        const {streamConnection} = this;
        streamConnection.createOffer({
            offerToReceiveAudio: false, offerToReceiveVideo: true,
        }).then(function (offer) {
            const access_info = JSON.parse(sessionStorage.getItem('access_info'));
            let accessToken = '';
            let deviceAccessToken = '';
            if (access_info) {
                accessToken = access_info.access_token;
                deviceAccessToken = access_info.device_access_token
            }

            // console.log('thisComponent.opponentDAT', thisComponent.opponentDAT);
            let payload = {
                data: {
                    category: 'ws',
                    service: 'Offer',
                    access_token: accessToken,
                    channel_type: "stream",
                    opponent_dat: thisComponent.opponentDAT,
                    label: deviceAccessToken,
                    sdp: offer,
                }
            };
            sendWS(payload);
            streamConnection.setLocalDescription(offer);
        }).catch(function (error) {
            console.log('SWS', 'An error has occurred.', error);
        });
        thisComponent.setState({
            isConnected: true,
        })
    };
    onAnswerStream = (answer) => {
        this.streamConnection.setRemoteDescription(new RTCSessionDescription(answer));
    };
    onCandidateStream = (candidate) => {
        this.streamConnection.addIceCandidate(new RTCIceCandidate(candidate));
    };
    onCandidateSC = (candidate) => {
        console.log('candidate', this.streamConnection);
        if (candidate.candidate && candidate.candidate.length > 0) {
            this.streamConnection.addIceCandidate(candidate).catch(e => {
                console.log('Failure during addIceCandidate(): ' + e.name);
            });
        }
    };
    createAnswerData = (offer, label) => {
        const {iceServers} = this.props;
        this.dataChannelLabel = label;
        let ua = navigator.userAgent.toLowerCase();
        console.log(ua);
        if (ua.indexOf('safari') !== -1) {
            if (ua.indexOf('chrome') > -1) {
                // Chrome
                console.log('SWS', 'Safari Test 1');
                this.dataConnection = new RTCPeerConnection(iceServers)
            } else {
                // Safari
                console.log('SWS', 'Safari Test 2');
                this.dataConnection = new RTCPeerConnection({
                    iceServers: [
                        {
                            "urls": "stun:stun.l.google.com:19302"
                        }
                    ]
                });
            }
        } else {
            console.log('SWS', 'Safari Test 3');
            this.dataConnection = new RTCPeerConnection(iceServers)
        }

        console.log('SWS', this.dataConnection);

        const access_info = JSON.parse(sessionStorage.getItem('access_info'));
        let accessToken = '';
        let deviceAccessToken = '';
        if (access_info) {
            accessToken = access_info.access_token;
            deviceAccessToken = access_info.device_access_token
        }

        const thisComponent = this;
        const {dataConnection, createAnswerSC} = this;

        // console.log(offer);
        // const d = JSON.parse(offer);
        thisComponent.dataConnection.setRemoteDescription(new RTCSessionDescription(offer));
        thisComponent.dataConnection.createAnswer(function (answer) {
            thisComponent.dataConnection.setLocalDescription(answer);
            let payload = {
                data: {
                    category: 'ws',
                    service: 'Answer',
                    access_token: accessToken,
                    opponent_dat: thisComponent.opponentDAT,
                    label: thisComponent.dataChannelLabel,
                    channel_type: "data",
                    sdp: answer,
                }
            };
            thisComponent.sendWS(payload)
        }, function (error) {
            console.log('createAnswer', error);
        });
        thisComponent.dataConnection.oniceconnectionstatechange = e => {
            console.log('dataConnection oniceconnectionstatechange', e);
        };
        thisComponent.dataConnection.onicecandidate = function (e) {
            if (e.candidate) {
                thisComponent.sendWS({
                    data: {
                        category: 'ws',
                        service: 'Candidate',
                        access_token: accessToken,
                        opponent_dat: thisComponent.opponentDAT,
                        label: thisComponent.dataChannelLabel,
                        channel_type: 'data',
                        candidate: {
                            type: 'candidate',
                            candidate: e.candidate,
                        },
                    }
                });
            }
        };
        thisComponent.dataConnection.onnegotiationneeded = e => {
            console.log('onnegotiationneeded', e);
        };
        thisComponent.dataConnection.ondatachannel = (e) => {
            console.log('ondatachannel');
            thisComponent.dataChannel = e.channel;
            thisComponent.dataChannel.onclose = () => {
                console.log('remoteDataChannel has closed:', thisComponent.dataChannel.label);
            };
            thisComponent.dataChannel.onopen = () => {
                console.log('remoteDataChannel has opened:', thisComponent.dataChannel.label);
                thisComponent.setState({
                    isOpenedDataChannel: true,
                })
                thisComponent.dataChannel.send(JSON.stringify({
                    data: {
                        category: 'ws',
                        service: 'RequestToOfferSC',
                        opponent_dat: deviceAccessToken,
                        channel_type: 'stream',
                    },
                }));
            };
            thisComponent.dataChannel.onmessage = e => {
                // console.log('remoteDataChannel onmessage', e);
                let d;
                if (e.data === "@PIKABU-CHUNK-START") {
                    thisComponent.chunk = "";
                    return;
                } else if (thisComponent.chunk !== null && thisComponent.chunk !== undefined) {
                    if (e.data === "@PIKABU-CHUNK-END") {
                        d = JSON.parse(thisComponent.chunk);
                        thisComponent.chunk = null;
                    } else {
                        thisComponent.chunk += e.data;
                        return;
                    }
                } else {
                    d = JSON.parse(e.data);
                }
                // console.log('SWS-DEBUG-9098', d.data);
                if (d.data) {
                    if (d.data.service === 'Offer') {
                        console.log('Offer', d.data);
                        if (thisComponent.streamConnection) {
                            if (thisComponent.streamConnection) {
                                console.log('sc close');
                                thisComponent.streamConnection.close();
                            }
                        }
                        createAnswerSC(d.data.sdp, d.data.opponent_dat, d.data.label, d.data.handle);
                    } else if (d.data.service === 'Candidate') {
                        this.onCandidateSC(d.data.candidate.candidate, d.data.opponent_dat, d.data.source);

                        // setTimeout(() => {
                        //     onCandidateSC(d.data.candidate.candidate, d.data.opponent_dat, d.data.source);
                        // }, 100);
                    }
                } else {

                }
            };
        }

        // dataConnection.createOffer()
        //     .then(function (offer) {
        //         // console.log('thisComponent.opponentDAT', thisComponent.opponentDAT);
        //         let payload = {
        //             data: {
        //                 category: 'ws',
        //                 service: 'Offer',
        //                 access_token: accessToken,
        //                 channel_type: "data",
        //                 opponent_dat: thisComponent.opponentDAT,
        //                 label: deviceAccessToken,
        //                 sdp: offer,
        //             }
        //         };
        //         thisComponent.sendWS(payload);
        //         dataConnection.setLocalDescription(offer);
        //     }).catch(function (error) {
        //     console.log('SWS', 'An error has occurred.', error);
        // });
    };
    onAnswerData = (answer) => {
        this.dataConnection.setRemoteDescription(new RTCSessionDescription(answer));
    };
    onCandidateData = (candidate) => {
        this.dataConnection.addIceCandidate(new RTCIceCandidate(candidate));
    };

    onClickPlayButton = () => {
        console.log('Play & Next');
        const message = JSON.stringify({
            command: 'switch',
        });
        this.dataChannel.send(message);
    };
    onClickHomeButton = () => {
        console.log('Home');
        const message = JSON.stringify({
            command: 'home',
        });
        this.dataChannel.send(message);
    };
    onClickBackButton = () => {
        console.log('Back');
        const message = JSON.stringify({
            command: 'back',
        });
        this.dataChannel.send(message);
    };
    onClickRecentButton = () => {
        console.log('Recent');
        const message = JSON.stringify({
            command: 'recent',
        });
        this.dataChannel.send(message);
    };

    componentDidMount() {
        console.log(this.props.device);
        this.opponentDAT = this.props.device.device_access_token
    }

    render() {
        const {isRequested, isConnected, isOpenedDataChannel} = this.state;
        const {onopenWS, onmessageWS, oncloseWS} = this;
        const {onClickPlayButton, onClickBackButton, onClickHomeButton, onClickRecentButton} = this;
        const {clearSelectedDevice} = this.props;
        return (
            <Fragment>
                {isConnected === false ?
                    <CustomLoader/>
                    : null
                }

                <Websocket url={wsHostUrl}
                           onOpen={onopenWS}
                           onMessage={onmessageWS}
                           onClose={oncloseWS}
                           reconnectIntervalInMilliSeconds={reconnectIntervalInMilliSeconds}
                           ref={Websocket => {
                               this.refWS = Websocket;
                           }}/>
                <div className={'viewer'} id={'viewer-base'}>
                    {isRequested ?
                        <div className={'viewer-loader'}>
                            <CustomLoader/>
                        </div>
                        :
                        null
                    }
                    <div className={'stream-contents'}>
                        <div className={'viewer-menu'}>
                            <AppBar position="static"
                                    justify="space-between"
                                    style={{background: '#000000'}}>
                                <Toolbar variant="dense"
                                >
                                    <Typography variant="h6" color="inherit">
                                        Pikabu Web
                                    </Typography>

                                    <div style={
                                        {
                                            marginLeft: 'auto',
                                        }}
                                    >
                                        {isOpenedDataChannel ?
                                            <IconButton style={{color: '#f9a602'}}
                                                        aria-label="Play & Next"
                                                        onClick={onClickPlayButton}>
                                                <PlayCircleFilledIcon/>
                                            </IconButton>
                                            : null
                                        }
                                        <IconButton style={{color: '#087006'}}
                                                    aria-label="back"
                                                    onClick={onClickBackButton}>
                                            <ArrowBackIcon/>
                                        </IconButton>
                                        <IconButton style={{color: '#087006'}}
                                                    aria-label="home"
                                                    onClick={onClickHomeButton}>
                                            <HomeIcon/>
                                        </IconButton>
                                        <IconButton style={{color: '#087006'}}
                                                    aria-label="recent"
                                                    onClick={onClickRecentButton}>
                                            <FilterNoneIcon/>
                                        </IconButton>
                                        <IconButton style={{color: '#ffffff'}}
                                                    aria-label="close"
                                                    onClick={clearSelectedDevice}>
                                            <CancelIcon/>
                                        </IconButton>
                                    </div>
                                </Toolbar>
                            </AppBar>
                        </div>
                        <div>
                            <video playsInline autoPlay className={'App-video'} id='app-video'/>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

}

export default StreamPage;
